module.exports = __webpack_public_path__ + "static/media/bannerimg.276c0406.png";